export default {
    email: {
        label: 'Email',
        maxLength: 75
    },
    password: {
        label: 'Password',
        maxLength: 35
    },
    fName: {
        label: 'First Name',
        maxLength: 50
    },
    lName: {
        label: 'Last Name',
        maxLength: 50
    },
    city: {
        label: 'City',
        maxLength: 75
    },
    province: {
        label: 'Province',
        maxLength: 75
    },
    dogName: {
        label: 'Dog Name',
        maxLength: 75
    },
    breedDesc: {
        label: 'Breed Description',
        maxLength: 150
    },
    specProjCode: {
        label: 'Special Project Code',
        maxLength: 25
    },

}